export class MockDialog {
  open = jasmine.createSpy('open');
  getDialogById = jasmine.createSpy('getDialogById');
}
